import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxUserRole} from "./dx-user-role";
import {DxUserPrivilege} from "./dx-user-privilege";
import {Privileges} from "../../../bdpk-common/domain/privileges.enum";


/**
 * В чем соль и боль:
 * Разные методологии\сервисы для аунтификации пользователя обычно возвращают
 * различный набор данных, но приложение в своей работе должно опираться на что-то одно
 * в контексте необходимого и достаточного состава полей.
 **/
@jsonObject
export class DxUserSession {

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true})
  id: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  login: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  name: string;

  /** Должность **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  position: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  token: string;

  /** Время протухания токена доступа (в сек.) от 1 января 1970 года GMT+0 */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false})
  tokenExpTime: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  refreshToken: string;

  /** Время протухания refresh токена (в сек.) от 1 января 1970 года GMT+0 */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false})
  refreshTokenExpTime: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  description: string;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false})
  email: string;

  /** Блокировка пользователя **/
  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  locked: boolean = false;

  /** Признак необходимости актуализации информации о пользователе. **/
  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  reload: boolean = false;

  @jsonArrayMember(DxUserRole, {emitDefaultValue: false, isRequired: false})
  roles: DxUserRole[] = [];

  @jsonArrayMember(DxUserPrivilege, {emitDefaultValue: false, preserveNull: false, isRequired: false})
  privileges: DxUserPrivilege[] = [];
  // [
  //   new DxUserPrivilege({id: Privileges.TASK_REGISTRY}),
  //   new DxUserPrivilege({id: Privileges.OBJECT_REGISTRY}),
  //   new DxUserPrivilege({id: Privileges.SCHEDULE_REGISTRY}),
  //   new DxUserPrivilege({id: Privileges.SCHEDULER_LOGS}),
  //   new DxUserPrivilege({id: Privileges.OPEN_OF_DEV_ENVS}),
  //   new DxUserPrivilege({id: Privileges.USER_RIGHTS_ADM}),
  // ];


  /**
   * @param id - look {@link Roles}
   */
  containsRoleId(id: number): boolean {
    return !!this.roles.find(role => role.id === id);
  }

  /**
   * @param id - look {@link Privileges}
   */
  containsPrivilegeId = (id: number): boolean => {
    if (this.privileges.find(privilege => privilege.id === Privileges.ALLOW_ALL)) {
      return true;
    }
    return !!this.privileges.find(privilege => privilege.id === id);
  }

  containsPrivilegeIds = (...ids: number[]): boolean => {
    return !!ids.find(id => this.containsPrivilegeId(id));
  }
}
